<app-de-wrapper *ngIf="noAvailablePaymentMethods || noResponseError">
  <div style="display: flex; flex-direction: column; align-items: center">
    <app-zaver-icon [size]="86" name="errorGhost" ></app-zaver-icon>
    <h3 class="general-error-text">Something went wrong.</h3>
  </div>
</app-de-wrapper>

<app-de-wrapper *ngIf="invalidPRStateForProceeding">
  <div style="display: flex; flex-direction: column; align-items: center">
    <app-zaver-icon [size]="86" name="plant" ></app-zaver-icon>
    <h3 class="general-error-text">The payment request was canceled.</h3>
  </div>
</app-de-wrapper>

<ng-container
  *ngIf="!noAvailablePaymentMethods && !loading && !invalidPRStateForProceeding"
>
  <div class="page-body">
    <div class="contents-container">
      <app-expandable-list-item
        *ngFor="let methodVM of paymentMethodsVM"
        [title]="methodVM.title"
        [description]="methodVM.subTitle"
        [imgSrc]="methodVM.imgSrc"
        [zaverIcon]="methodVM.zaverIcon"
        [bulletPoints]="methodVM.bulletPoints"
        [color]="color"
        [selected]="methodVM === selectedPaymentMethodVM"
        [isFirstItem]="methodVM === paymentMethodsVM[0]"
        [isLastItem]="
          methodVM === paymentMethodsVM[paymentMethodsVM.length - 1]
        "
        (click)="selectPaymentMethod(methodVM)"
        [showTermsLink]="true"
        [linkText]="'View terms'"
        (onTermsClick)="openModalWithTerms()"
      ></app-expandable-list-item>

      <div>
        <div class="pr-information">
          <div class="pr-details-container">
            <span class="pr-details-text">Total amount including VAT</span>
          </div>

          <div class="pr-amount">
            {{ state.totalCheckoutValue | value }}
          </div>
        </div>

        <zaver-primary-button
          [text]="'Continue'"
          (click)="handleContinueClick()"
          [disabled]="navigationInProgress"
        ></zaver-primary-button>
        <div style="display: flex; justify-content: center; margin-top: 16px">
          <zaver-button-link
            [text]="'View details'"
            (click)="openModalWithTerms()"
          ></zaver-button-link>
        </div>
      </div>

      <div class="disclaimer-paragraph">
        By continuing, I agree to Zaver's terms and conditions
        <a
          class="disclaimer-link"
          target="_blank"
          href="https://zaver.com/terms-and-conditions"
          >Zaver's terms and conditions</a
        >
      </div>
    </div>
  </div>

  <zaver-checkout-modal
    *ngIf="modalActive"
    [buttonText]="'Close'"
    [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
    (onClose)="deactivateModal()"
  >
    <app-selector
      #selector
      *ngIf="!!selectorItems"
      [selectorItems]="selectorItems"
      [selectedItem]="selectedItem"
    ></app-selector>
  </zaver-checkout-modal>
</ng-container>
